var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5971 8.952C15.4398 8.50588 15.1478 8.11963 14.7614 7.84662C14.3751 7.57362 13.9135 7.42733 13.4405 7.42798H11.6713C11.1676 7.42715 10.6814 7.61272 10.3063 7.94893C9.93121 8.28515 9.69378 8.74826 9.63972 9.24907C9.58566 9.74987 9.71879 10.253 10.0135 10.6615C10.3082 11.07 10.7436 11.3551 11.2359 11.4618L13.9291 12.0515C14.4797 12.1723 14.9663 12.4922 15.2954 12.9498C15.6246 13.4075 15.7731 13.9705 15.7126 14.531C15.652 15.0914 15.3866 15.6097 14.9672 15.9864C14.5479 16.3632 14.0042 16.5717 13.4405 16.5721H11.9165C10.9222 16.5721 10.0753 15.9361 9.76157 15.0464",
    strokeWidth: 1.71431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6793 7.428V5.14282",
    strokeWidth: 1.71431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6793 18.8574V16.5723",
    strokeWidth: 1.71431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98901 14.5716C2.59212 17.1138 4.06942 19.3633 6.16275 20.9269C8.25607 22.4906 10.8323 23.2688 13.4412 23.1258C16.0501 22.9827 18.5258 21.9274 20.4356 20.1443C22.3454 18.3612 23.5679 15.9637 23.8895 13.3707C24.211 10.7777 23.6111 8.15423 22.1946 5.95865C20.7782 3.76308 18.6352 2.13508 16.1403 1.35915C13.6453 0.583212 10.957 0.708696 8.54519 1.71367C6.13336 2.71864 4.15138 4.53919 2.9456 6.85716",
    strokeWidth: 1.71431,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69055 3.42871V7.71449H5.97633",
    strokeWidth: 1.71431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0004,
    height: 24.0004,
    fill: "white",
    transform: "translate(0.833374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.210aeec74e56f7021e067aeffc4bbf5a.svg";
export { ForwardRef as ReactComponent };